import layout from '@/layout'

export default {
  path: '/pre_close_out',
  component: layout,
  redirect: '/pre_close_out/page7',
  name: 'pre_close_out_page7',
  meta: {
    title: 'pre_close_out',
    icon: 'el-icon-d-arrow-right'
  },
  children: [
    {
      path: '/pre_close_out/page7',
      name: 'pre_close_out_page7',
      component: () => import('@/views/pre_settle/pre_close/out/index7'),
      meta: {
        title: 'pre_close_out_page7',
        icon: 'el-icon-d-arrow-right'
      }
    }
  ]
}
